export default __webpack_public_path__ + "static/media/ValuMass-400-Inline.0be09b5e.png";